// components/UserCanister/candid/index.ts
import { Actor, HttpAgent } from "@dfinity/agent";
import type { ActorSubclass, HttpAgentOptions, ActorConfig, Agent } from "@dfinity/agent";
import { Principal } from "@dfinity/principal";
import { USER_SERVICE } from './main.did';
import { idlFactory } from './main.did.js';

export type { USER_SERVICE };

export const createUserActor = (
    canisterId: string | Principal,
    options?: {
        agentOptions?: HttpAgentOptions;
        actorOptions?: ActorConfig;
        agent?: Agent;
    }
): ActorSubclass<USER_SERVICE> => {
    const agent = options?.agent || new HttpAgent({
        ...options?.agentOptions,
        verifyQuerySignatures: false  // Add this line
    });

    if (process.env.DFX_NETWORK !== 'ic') {
        agent.fetchRootKey().catch(err => {
            console.warn('Unable to fetch root key. Check to ensure that your local replica is running');
            console.error(err);
        });
    }

    return Actor.createActor(idlFactory, {
        agent,
        canisterId: typeof canisterId === 'string' ? Principal.fromText(canisterId) : canisterId,
        ...options?.actorOptions,
    });
};